module.exports = __webpack_public_path__ + "img/studywayIcon3.b79463e0.png";